import React, { useEffect, useRef, useState } from 'react';

// A new activity entry, shown on the map for a moment as it happens — the web's counterpart of the
// phone's NotificationToast. The log itself is in Profile → Activity (since 2026-10-28; it used to be
// a panel along the bottom of the map). Not a second source of truth: it shows the newest entry of
// the same list, and only ones added after the page loaded, so three days of stored entries never
// replay as though they had just happened.
const SHOW_MS = 3200;

const wrapStyle = (visible) => ({
  position: 'fixed',
  left: '50%',
  bottom: 24,
  transform: `translate(-50%, ${visible ? 0 : 12}px)`,
  opacity: visible ? 1 : 0,
  transition: 'opacity 0.22s ease, transform 0.22s ease',
  maxWidth: 'min(520px, calc(100vw - 32px))',
  padding: '10px 16px',
  borderRadius: 16,
  background: 'var(--surface, #fff)',
  color: 'var(--ink, #1c1c1e)',
  boxShadow: 'var(--shadow-lg, 0 6px 24px rgba(0,0,0,0.18))',
  border: '1px solid var(--line, #e3e3e8)',
  fontSize: '0.92rem',
  fontWeight: 600,
  zIndex: 1500,
  pointerEvents: 'none',
});
const ACCENT = { green: '#2e7d32', red: '#c62828', blue: '#1565c0', purple: '#512da8' };

const ActivityToast = ({ entries }) => {
  const loadedAt = useRef(Date.now());
  const lastShown = useRef(0);
  const timer = useRef(null);
  const [shown, setShown] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const latest = entries?.length ? entries[entries.length - 1] : null;
    if (!latest || latest.rawTime <= loadedAt.current || latest.rawTime <= lastShown.current) return;
    lastShown.current = latest.rawTime;
    clearTimeout(timer.current);
    setShown(latest);
    setVisible(true);
    timer.current = setTimeout(() => setVisible(false), SHOW_MS);
  }, [entries]);

  useEffect(() => () => clearTimeout(timer.current), []);

  if (!shown) return null;
  return (
    <div style={wrapStyle(visible)} role="status" aria-live="polite">
      {ACCENT[shown.color] && <span style={{ display: 'inline-block', width: 8, height: 8, borderRadius: 4, background: ACCENT[shown.color], marginRight: 8, verticalAlign: 'middle' }} />}
      {shown.msg}
    </div>
  );
};

export default ActivityToast;
